export default "__VITE_ASSET__Bs4cLMH2__"